import { NEW_PRODUCTS_LIST } from '../../ahm-constants/ui';
import { Product } from '../../types/__codegen__/ahm-api/graphql';
import type { ProductTypeType } from '../../types/product';

const isProductNew = (
  productId: Product['id'],
  parentProductId: Product['parentProductId'],
  productType: ProductTypeType,
): boolean => {
  if (!(productType in NEW_PRODUCTS_LIST)) {
    return false;
  }

  const newProducts: readonly string[] = NEW_PRODUCTS_LIST[productType as keyof typeof NEW_PRODUCTS_LIST];

  if (!newProducts) {
    return false;
  }

  return newProducts.includes(productId) || (parentProductId ? newProducts.includes(parentProductId) : false);
};

export default isProductNew;
